import { createAction, props } from '@ngrx/store';
import { QuotePageData } from '@cpak/adp-cpak-bff-service-models';
import { BOMModel } from '@cpak/adp-cpak-quotes-service-models';

export const updateNotSavedBOMForPack = createAction(
  'Pack BOM has not saved changes',
  props<{
    packId: string;
    packData: Partial<QuotePageData>;
    changedProducts: string[];
    bom: BOMModel;
  }>()
);

export const removeNotSavedChangesForPack = createAction(
  'Clear not saved changes for Pack',
  props<{ packId: string }>()
);

export const removeNotSavedChangesForAllPacks = createAction('Clear not saved changes for all Packs');
